export const averageGeolocation = (coords) => {
	if (coords.length === 1) {
		return coords[0];
	}

	let x = 0.0;
	let y = 0.0;
	let z = 0.0;

	for (const coord of coords) {
		const latitude = coord.latitude * Math.PI / 180;
		const longitude = coord.longitude * Math.PI / 180;

		x += Math.cos(latitude) * Math.cos(longitude);
		y += Math.cos(latitude) * Math.sin(longitude);
		z += Math.sin(latitude);
	}

	const total = coords.length;

	x = x / total;
	y = y / total;
	z = z / total;

	const centralLongitude = Math.atan2(y, x);
	const centralSquareRoot = Math.sqrt(x * x + y * y);
	const centralLatitude = Math.atan2(z, centralSquareRoot);

	const center = {
		latitude: centralLatitude * 180 / Math.PI,
		longitude: centralLongitude * 180 / Math.PI
	};
	return center;
};

export const calculateZoomLevel = (map, markerPositions) => {
	const bounds = new window.google.maps.LatLngBounds();

	// Extend the bounds to include all marker positions
	markerPositions.forEach((position) => {
		bounds.extend(new window.google.maps.LatLng(position.latitude, position.longitude));
	});

	const mapDiv = map.getDiv();
	const mapWidth = mapDiv.offsetWidth;
	const mapHeight = mapDiv.offsetHeight;

	if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
		return 10; // Default zoom level
	} else {
		const ne = map.getProjection().fromLatLngToPoint(bounds.getNorthEast());
		const sw = map.getProjection().fromLatLngToPoint(bounds.getSouthWest());

		const worldCoordWidth = Math.abs(ne.x - sw.x);
		const worldCoordHeight = Math.abs(ne.y - sw.y);

		// Fit padding, 25 pixels on each side
		const padding = 55;

		// Zoom level calculation based on the map width and height
		const zoomX = Math.floor(Math.log(mapWidth - padding * 2) / Math.log(2) - Math.log(worldCoordWidth) / Math.log(2));
		const zoomY = Math.floor(Math.log(mapHeight - padding * 2) / Math.log(2) - Math.log(worldCoordHeight) / Math.log(2));

		return Math.min(zoomX, zoomY);
	}
}
